import CustomBadge from '../../DriverPopUp/common/CustomBadge';
import { withStyles } from '@material-ui/core/styles';
import { getFormattedValue } from '../utils';
const styles = () => ({
  divStyle: {
    display: 'flex',
    justifyContent: "flex-start",
    margin: '4px 0px'
  }
});
const ShipmentBadgeList = ({ classes, pieces, hu, weight, stc, pkgType, isPickupPro = false }) => (
  <div className={classes.divStyle}>
    <CustomBadge value={getFormattedValue(pieces)} labelText="PCS" />
    {!isPickupPro && <CustomBadge value={getFormattedValue(stc)} labelText="STC" />}
    <CustomBadge value={getFormattedValue(hu)} labelText="HU" />
    <CustomBadge value={getFormattedValue(weight)} labelText="LBS" />
    {pkgType && <CustomBadge value={getFormattedValue(pkgType)} labelText="PKG TYPE" />}
  </div>
);
export default withStyles(styles)(ShipmentBadgeList);
